import React, { PureComponent } from "react";
import ReactTooltip from 'react-tooltip'

export default class ChartBoxHeader extends PureComponent {

	render() {
		const {
			chartType, chartNumber,
			solarModal, moonModal, transitsModal, backToNatal, chartModal,
			chartPrint
		} = this.props
		const chartFatherState = 'chart'+chartNumber;
		return (
			<div className="chart-box--header">
				<span style={{ maxWidth: "70%" }} />
				<span className="chart-box--header-icon">
					<a href={document.location.href} data-tip data-for='loadChart'>
						<i className="icon-download" onClick={() => chartModal(chartFatherState, chartNumber)} />
					</a>
					<ReactTooltip id='loadChart' place="bottom" type="info" effect="float">
						<span>Carregar mapa arquivado</span>
					</ReactTooltip>
					<a href={document.location.href} data-tip data-for='printChart'>
						<i className="icon-file-pdf" onClick={() => chartPrint(chartFatherState, chartNumber)}/>
					</a>
					<ReactTooltip id='printChart' place="bottom" type="info" effect="float">
						<span>Baixar PDF</span>
					</ReactTooltip>
					<div className="dropdown">
						<button className="dropbtn">
							<i className="icon-configuracoes" />
						</button>
						<div className="dropdown-content">
							<a href={document.location.href} onClick={() => solarModal(chartFatherState, chartNumber)}>Revolução Solar</a>
							<a href={document.location.href} onClick={() => moonModal(chartFatherState, chartNumber)}>Revolução Lunar</a>
							<a href={document.location.href} onClick={() => transitsModal(chartFatherState, chartNumber)}>Trânsito Direto</a>
							<a
								href={document.location.href}
								onClick={() => backToNatal(chartFatherState, chartNumber)}
								className={chartType === "natal" ? "hide" : null}
							>
								Voltar ao Mapa Natal
							</a>
						</div>
					</div>
				</span>
			</div>
		);
	}
}
